export enum DiscountMode {
    PERCENTAGE = "PERCENTAGE",
    FIXED = "FIXED",
}